/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // Initialize Masonry if layout is grid and settings are correct
    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }

    // Initialize Slider if layout is a slider
    if(this.collection_style == 'slider') {
      this.createSlider();
    }
  },

  createSlider: function() {
    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    // Define arrow shape (add a default shape if not set)
    const arrowShape = {
      left: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><polygon points="6,0 0,5 6,10"/></svg>',
      right: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><polygon points="4,0 10,5 4,10"/></svg>'
    }

    // First, check if Flickity is already initialized and destroy it if necessary
    if (featuredCollectionSlider.hasClass('flickity-enabled')) {
      featuredCollectionSlider.flickity('destroy');
    }

    // Initialize the Flickity slider
    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on('settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize');
          });
        }
      }
    });
  },

  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    if ($slider.length) {
      $slider.flickity('destroy');
    }
  }
}

/******/ })()
;
